module.exports = __webpack_public_path__ + "static/img/model-bg13.1f41090.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg13.jpg
// module id = 2jvW
// module chunks = 0